export default __webpack_public_path__ + "static/media/CGhomeDark.e8a55cae.png";